/**
 * Theme Toggle Button Component
 */

import { themeManager } from '../../services/themeManager';

export class ThemeToggle {
    private button: HTMLButtonElement;

    constructor() {
        this.button = this.createButton();
        this.attachEventListeners();

        // Subscribe to theme updates to handle external changes (e.g. keyboard shortcuts)
        themeManager.subscribe(() => this.updateIcon());
    }

    /**
     * Create the toggle button element
     */
    private createButton(): HTMLButtonElement {
        const button = document.createElement('button');
        button.id = 'theme-toggle';
        button.className = 'theme-toggle';
        button.setAttribute('aria-label', 'Toggle theme');
        button.setAttribute('title', 'Toggle light/dark mode (Shortcut: T)');
        return button;
    }

    /**
     * Attach event listeners
     */
    private attachEventListeners(): void {
        this.button.addEventListener('click', () => {
            themeManager.toggleTheme();
        });
    }

    /**
     * Update button icon based on current theme
     */
    private updateIcon(): void {
        const theme = themeManager.getTheme();

        if (theme === 'dark') {
            // Sun icon for switching to light mode
            this.button.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="5"/>
          <line x1="12" y1="1" x2="12" y2="3"/>
          <line x1="12" y1="21" x2="12" y2="23"/>
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
          <line x1="1" y1="12" x2="3" y2="12"/>
          <line x1="21" y1="12" x2="23" y2="12"/>
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
        </svg>
      `;
        } else {
            // Moon icon for switching to dark mode
            this.button.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
        </svg>
      `;
        }
    }

    /**
     * Get the button element
     */
    getElement(): HTMLButtonElement {
        return this.button;
    }
}
